var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3398 21.3403C26.2234 16.4577 26.2234 8.54396 21.3398 3.66134C16.4562 -1.22128 8.54876 -1.22128 3.66518 3.66134C-1.21839 8.55178 -1.21839 16.4577 3.66518 21.3403C8.54094 26.2151 16.4562 26.223 21.3398 21.3403ZM6.47816 12.7626C6.78285 12.4579 7.28294 12.4579 7.58769 12.7626L10.135 15.3015L17.4174 8.03619C17.7299 7.73933 18.2222 7.73933 18.5269 8.04397C18.8316 8.34865 18.8316 8.84083 18.5269 9.14551L10.6819 16.9577C10.5335 17.114 10.3303 17.1842 10.135 17.1842C9.9318 17.1842 9.73646 17.114 9.58018 16.9577L6.47816 13.8719C6.1734 13.5672 6.1734 13.0672 6.47816 12.7626Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkSelected);
export default __webpack_public_path__ + "static/media/check_mark_selected.3bae6242ff85a1c0308dd8486dacd738.svg";
export { ForwardRef as ReactComponent };